import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { groupFromTab } from '../pages/gl/GLJournals/urlGroup';

// Chờ ghi sổ (/pnl/PNLPostings) và Hạch toán lại (/pnl/PNLReEntries) gộp vào danh sách Phiếu kế toán (đợt 5, TH-00):
// liên kết cũ mở danh sách mới ở đúng nhóm.
export function PNLPostingsRedirect() {
    const location = useLocation();
    const tab = new URLSearchParams(location.search).get('tab');
    return <Navigate replace to={'/gl/GLJournals?group=' + groupFromTab(tab)} />;
}

export function PNLReEntriesRedirect() {
    return <Navigate replace to={'/gl/GLJournals?group=Pending'} />;
}
